import React from 'react';
import { Link } from 'react-router-dom';
import { CountdownTimer } from "@/components/CountdownTimer";
import heroImage from "@/assets/hero-2026.jpg.asset.json";

const HeroVideoSlider = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      <Link to="/agenda" className="block absolute inset-0">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src={heroImage.url}
            alt="AI World Congress 2026 - November 25-26, London Europe UK - AI Conference - AI Events 2026"
            className="absolute w-full h-full object-cover cursor-pointer"
            fetchPriority="high"
            loading="eager"
            decoding="async"
          />
        </div>
      </Link>

      <div className="absolute bottom-[15%] left-0 right-0 z-30">
        <div className="animate-fade-in">
          <CountdownTimer targetDate={new Date('November 25, 2026 09:00:00')} />
        </div>
      </div>
    </section>
  );
};

export default HeroVideoSlider;
